function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { BOM, DOCUMENT, FLOW_END, SCALAR } from './cst.js';
/*
START -> stream

stream
  directive -> line-end -> stream
  indent + line-end -> stream
  [else] -> line-start

line-end
  comment -> line-end
  newline -> .
  input-end -> END

line-start
  doc-start -> doc
  doc-end -> stream
  [else] -> indent -> block-start

block-start
  seq-item-start -> block-start
  explicit-key-start -> block-start
  map-value-start -> block-start
  [else] -> doc

doc
  line-end -> line-start
  spaces -> doc
  anchor -> doc
  tag -> doc
  flow-start -> flow -> doc
  flow-end -> error -> doc
  seq-item-start -> error -> doc
  explicit-key-start -> error -> doc
  map-value-start -> doc
  alias -> doc
  quote-start -> quoted-scalar -> doc
  block-scalar-header -> line-end -> block-scalar(min) -> line-start
  [else] -> plain-scalar(false, min) -> doc

flow
  line-end -> flow
  spaces -> flow
  anchor -> flow
  tag -> flow
  flow-start -> flow -> flow
  flow-end -> .
  seq-item-start -> error -> flow
  explicit-key-start -> flow
  map-value-start -> flow
  alias -> flow
  quote-start -> quoted-scalar -> flow
  comma -> flow
  [else] -> plain-scalar(true, 0) -> flow

quoted-scalar
  quote-end -> .
  [else] -> quoted-scalar

block-scalar(min)
  newline + peek(indent < min) -> .
  [else] -> block-scalar(min)

plain-scalar(is-flow, min)
  scalar-end(is-flow) -> .
  peek(newline + (indent < min)) -> .
  [else] -> plain-scalar(min)
*/

function isEmpty(ch) {
  switch (ch) {
    case undefined:
    case ' ':
    case '\n':
    case '\r':
    case '\t':
      return true;

    default:
      return false;
  }
}

var hexDigits = new Set('0123456789ABCDEFabcdef');
var tagChars = new Set("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-#;/?:@&=+$_.!~*'()");
var flowIndicatorChars = new Set(',[]{}');
var invalidAnchorChars = new Set(' ,[]{}\n\r\t');

var isNotAnchorChar = function isNotAnchorChar(ch) {
  return !ch || invalidAnchorChars.has(ch);
};
/**
 * Splits an input string into lexical tokens, i.e. smaller strings that are
 * easily identifiable by `tokens.tokenType()`.
 *
 * Lexing starts always in a "stream" context. Incomplete input may be buffered
 * until a complete token can be emitted.
 *
 * In addition to slices of the original input, the following control characters
 * may also be emitted:
 *
 * - `\x02` (Start of Text): A document starts with the next token
 * - `\x18` (Cancel): Unexpected end of flow-mode (indicates an error)
 * - `\x1f` (Unit Separator): Next token is a scalar value
 * - `\u{FEFF}` (Byte order mark): Emitted separately outside documents
 */


var Lexer = /*#__PURE__*/function () {
  function Lexer() {
    _classCallCheck(this, Lexer);

    /**
     * Flag indicating whether the end of the current buffer marks the end of
     * all input
     */
    this.atEnd = false;
    /**
     * Explicit indent set in block scalar header, as an offset from the current
     * minimum indent, so e.g. set to 1 from a header `|2+`. Set to -1 if not
     * explicitly set.
     */

    this.blockScalarIndent = -1;
    /**
     * Block scalars that include a + (keep) chomping indicator in their header
     * include trailing empty lines, which are otherwise excluded from the
     * scalar's contents.
     */

    this.blockScalarKeep = false;
    /** Current input */

    this.buffer = '';
    /**
     * Flag noting whether the map value indicator : can immediately follow this
     * node within a flow context.
     */

    this.flowKey = false;
    /** Count of surrounding flow collection levels. */

    this.flowLevel = 0;
    /**
     * Minimum level of indentation required for next lines to be parsed as a
     * part of the current scalar value.
     */

    this.indentNext = 0;
    /** Indentation level of the current line. */

    this.indentValue = 0;
    /** Position of the next \n character. */

    this.lineEndPos = null;
    /** Stores the state of the lexer if reaching the end of incpomplete input */

    this.next = null;
    /** A pointer to `buffer`; the current position of the lexer. */

    this.pos = 0;
  }
  /**
   * Generate YAML tokens from the `source` string. If `incomplete`,
   * a part of the last line may be left as a buffer for the next call.
   *
   * @returns A generator of lexical tokens
   */


  _createClass(Lexer, [{
    key: "lex",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function lex(source) {
      var _this$next;

      var incomplete,
          next,
          _args = arguments;
      return _regeneratorRuntime.wrap(function lex$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              incomplete = _args.length > 1 && _args[1] !== undefined ? _args[1] : false;

              if (!source) {
                _context.next = 6;
                break;
              }

              if (!(typeof source !== 'string')) {
                _context.next = 4;
                break;
              }

              throw TypeError('source is not a string');

            case 4:
              this.buffer = this.buffer ? this.buffer + source : source;
              this.lineEndPos = null;

            case 6:
              this.atEnd = !incomplete;
              next = (_this$next = this.next) !== null && _this$next !== void 0 ? _this$next : 'stream';

            case 8:
              if (!(next && (incomplete || this.hasChars(1)))) {
                _context.next = 13;
                break;
              }

              return _context.delegateYield(this.parseNext(next), "t0", 10);

            case 10:
              next = _context.t0;
              _context.next = 8;
              break;

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, lex, this);
    })
  }, {
    key: "atLineEnd",
    value: function atLineEnd() {
      var i = this.pos;
      var ch = this.buffer[i];

      while (ch === ' ' || ch === '\t') {
        ch = this.buffer[++i];
      }

      if (!ch || ch === '#' || ch === '\n') return true;
      if (ch === '\r') return this.buffer[i + 1] === '\n';
      return false;
    }
  }, {
    key: "charAt",
    value: function charAt(n) {
      return this.buffer[this.pos + n];
    }
  }, {
    key: "continueScalar",
    value: function continueScalar(offset) {
      var ch = this.buffer[offset];

      if (this.indentNext > 0) {
        var indent = 0;

        while (ch === ' ') {
          ch = this.buffer[++indent + offset];
        }

        if (ch === '\r') {
          var next = this.buffer[indent + offset + 1];
          if (next === '\n' || !next && !this.atEnd) return offset + indent + 1;
        }

        return ch === '\n' || indent >= this.indentNext || !ch && !this.atEnd ? offset + indent : -1;
      }

      if (ch === '-' || ch === '.') {
        var dt = this.buffer.substr(offset, 3);
        if ((dt === '---' || dt === '...') && isEmpty(this.buffer[offset + 3])) return -1;
      }

      return offset;
    }
  }, {
    key: "getLine",
    value: function getLine() {
      var end = this.lineEndPos;

      if (typeof end !== 'number' || end !== -1 && end < this.pos) {
        end = this.buffer.indexOf('\n', this.pos);
        this.lineEndPos = end;
      }

      if (end === -1) return this.atEnd ? this.buffer.substring(this.pos) : null;
      if (this.buffer[end - 1] === '\r') end -= 1;
      return this.buffer.substring(this.pos, end);
    }
  }, {
    key: "hasChars",
    value: function hasChars(n) {
      return this.pos + n <= this.buffer.length;
    }
  }, {
    key: "setNext",
    value: function setNext(state) {
      this.buffer = this.buffer.substring(this.pos);
      this.pos = 0;
      this.lineEndPos = null;
      this.next = state;
      return null;
    }
  }, {
    key: "peek",
    value: function peek(n) {
      return this.buffer.substr(this.pos, n);
    }
  }, {
    key: "parseNext",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseNext(next) {
      return _regeneratorRuntime.wrap(function parseNext$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.t0 = next;
              _context2.next = _context2.t0 === 'stream' ? 3 : _context2.t0 === 'line-start' ? 5 : _context2.t0 === 'block-start' ? 7 : _context2.t0 === 'doc' ? 9 : _context2.t0 === 'flow' ? 11 : _context2.t0 === 'quoted-scalar' ? 13 : _context2.t0 === 'block-scalar' ? 15 : _context2.t0 === 'plain-scalar' ? 17 : 19;
              break;

            case 3:
              return _context2.delegateYield(this.parseStream(), "t1", 4);

            case 4:
              return _context2.abrupt("return", _context2.t1);

            case 5:
              return _context2.delegateYield(this.parseLineStart(), "t2", 6);

            case 6:
              return _context2.abrupt("return", _context2.t2);

            case 7:
              return _context2.delegateYield(this.parseBlockStart(), "t3", 8);

            case 8:
              return _context2.abrupt("return", _context2.t3);

            case 9:
              return _context2.delegateYield(this.parseDocument(), "t4", 10);

            case 10:
              return _context2.abrupt("return", _context2.t4);

            case 11:
              return _context2.delegateYield(this.parseFlowCollection(), "t5", 12);

            case 12:
              return _context2.abrupt("return", _context2.t5);

            case 13:
              return _context2.delegateYield(this.parseQuotedScalar(), "t6", 14);

            case 14:
              return _context2.abrupt("return", _context2.t6);

            case 15:
              return _context2.delegateYield(this.parseBlockScalar(), "t7", 16);

            case 16:
              return _context2.abrupt("return", _context2.t7);

            case 17:
              return _context2.delegateYield(this.parsePlainScalar(), "t8", 18);

            case 18:
              return _context2.abrupt("return", _context2.t8);

            case 19:
            case "end":
              return _context2.stop();
          }
        }
      }, parseNext, this);
    })
  }, {
    key: "parseStream",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseStream() {
      var line, dirEnd, cs, ch, _ch, n, sp;

      return _regeneratorRuntime.wrap(function parseStream$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              line = this.getLine();

              if (!(line === null)) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return", this.setNext('stream'));

            case 3:
              if (!(line[0] === BOM)) {
                _context3.next = 6;
                break;
              }

              return _context3.delegateYield(this.pushCount(1), "t0", 5);

            case 5:
              line = line.substring(1);

            case 6:
              if (!(line[0] === '%')) {
                _context3.next = 36;
                break;
              }

              dirEnd = line.length;
              cs = line.indexOf('#');

            case 9:
              if (!(cs !== -1)) {
                _context3.next = 19;
                break;
              }

              ch = line[cs - 1];

              if (!(ch === ' ' || ch === '\t')) {
                _context3.next = 16;
                break;
              }

              dirEnd = cs - 1;
              return _context3.abrupt("break", 19);

            case 16:
              cs = line.indexOf('#', cs + 1);

            case 17:
              _context3.next = 9;
              break;

            case 19:
              if (!true) {
                _context3.next = 28;
                break;
              }

              _ch = line[dirEnd - 1];

              if (!(_ch === ' ' || _ch === '\t')) {
                _context3.next = 25;
                break;
              }

              dirEnd -= 1;
              _context3.next = 26;
              break;

            case 25:
              return _context3.abrupt("break", 28);

            case 26:
              _context3.next = 19;
              break;

            case 28:
              return _context3.delegateYield(this.pushCount(dirEnd), "t1", 29);

            case 29:
              _context3.t2 = _context3.t1;
              return _context3.delegateYield(this.pushSpaces(true), "t3", 31);

            case 31:
              _context3.t4 = _context3.t3;
              n = _context3.t2 + _context3.t4;
              return _context3.delegateYield(this.pushCount(line.length - n), "t5", 34);

            case 34:
              // possible comment
              this.pushNewline();
              return _context3.abrupt("return", 'stream');

            case 36:
              if (!this.atLineEnd()) {
                _context3.next = 42;
                break;
              }

              return _context3.delegateYield(this.pushSpaces(true), "t6", 38);

            case 38:
              sp = _context3.t6;
              return _context3.delegateYield(this.pushCount(line.length - sp), "t7", 40);

            case 40:
              return _context3.delegateYield(this.pushNewline(), "t8", 41);

            case 41:
              return _context3.abrupt("return", 'stream');

            case 42:
              _context3.next = 44;
              return DOCUMENT;

            case 44:
              return _context3.delegateYield(this.parseLineStart(), "t9", 45);

            case 45:
              return _context3.abrupt("return", _context3.t9);

            case 46:
            case "end":
              return _context3.stop();
          }
        }
      }, parseStream, this);
    })
  }, {
    key: "parseLineStart",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseLineStart() {
      var ch, s;
      return _regeneratorRuntime.wrap(function parseLineStart$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              ch = this.charAt(0);

              if (!(!ch && !this.atEnd)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return", this.setNext('line-start'));

            case 3:
              if (!(ch === '-' || ch === '.')) {
                _context4.next = 12;
                break;
              }

              if (!(!this.atEnd && !this.hasChars(4))) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", this.setNext('line-start'));

            case 6:
              s = this.peek(3);

              if (!((s === '---' || s === '...') && isEmpty(this.charAt(3)))) {
                _context4.next = 12;
                break;
              }

              return _context4.delegateYield(this.pushCount(3), "t0", 9);

            case 9:
              this.indentValue = 0;
              this.indentNext = 0;
              return _context4.abrupt("return", s === '---' ? 'doc' : 'stream');

            case 12:
              return _context4.delegateYield(this.pushSpaces(false), "t1", 13);

            case 13:
              this.indentValue = _context4.t1;
              if (this.indentNext > this.indentValue && !isEmpty(this.charAt(1))) this.indentNext = this.indentValue;
              return _context4.delegateYield(this.parseBlockStart(), "t2", 16);

            case 16:
              return _context4.abrupt("return", _context4.t2);

            case 17:
            case "end":
              return _context4.stop();
          }
        }
      }, parseLineStart, this);
    })
  }, {
    key: "parseBlockStart",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseBlockStart() {
      var _this$peek, _this$peek2, ch0, ch1, n;

      return _regeneratorRuntime.wrap(function parseBlockStart$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _this$peek = this.peek(2), _this$peek2 = _slicedToArray(_this$peek, 2), ch0 = _this$peek2[0], ch1 = _this$peek2[1];

              if (!(!ch1 && !this.atEnd)) {
                _context5.next = 3;
                break;
              }

              return _context5.abrupt("return", this.setNext('block-start'));

            case 3:
              if (!((ch0 === '-' || ch0 === '?' || ch0 === ':') && isEmpty(ch1))) {
                _context5.next = 13;
                break;
              }

              return _context5.delegateYield(this.pushCount(1), "t0", 5);

            case 5:
              _context5.t1 = _context5.t0;
              return _context5.delegateYield(this.pushSpaces(true), "t2", 7);

            case 7:
              _context5.t3 = _context5.t2;
              n = _context5.t1 + _context5.t3;
              this.indentNext = this.indentValue + 1;
              this.indentValue += n;
              return _context5.delegateYield(this.parseBlockStart(), "t4", 12);

            case 12:
              return _context5.abrupt("return", _context5.t4);

            case 13:
              return _context5.abrupt("return", 'doc');

            case 14:
            case "end":
              return _context5.stop();
          }
        }
      }, parseBlockStart, this);
    })
  }, {
    key: "parseDocument",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseDocument() {
      var line, n;
      return _regeneratorRuntime.wrap(function parseDocument$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.delegateYield(this.pushSpaces(true), "t0", 1);

            case 1:
              line = this.getLine();

              if (!(line === null)) {
                _context6.next = 4;
                break;
              }

              return _context6.abrupt("return", this.setNext('doc'));

            case 4:
              return _context6.delegateYield(this.pushIndicators(), "t1", 5);

            case 5:
              n = _context6.t1;
              _context6.t2 = line[n];
              _context6.next = _context6.t2 === '#' ? 9 : _context6.t2 === undefined ? 10 : _context6.t2 === '{' ? 13 : _context6.t2 === '[' ? 13 : _context6.t2 === '}' ? 17 : _context6.t2 === ']' ? 17 : _context6.t2 === '*' ? 19 : _context6.t2 === '"' ? 21 : _context6.t2 === "'" ? 21 : _context6.t2 === '|' ? 23 : _context6.t2 === '>' ? 23 : 33;
              break;

            case 9:
              return _context6.delegateYield(this.pushCount(line.length - n), "t3", 10);

            case 10:
              return _context6.delegateYield(this.pushNewline(), "t4", 11);

            case 11:
              return _context6.delegateYield(this.parseLineStart(), "t5", 12);

            case 12:
              return _context6.abrupt("return", _context6.t5);

            case 13:
              return _context6.delegateYield(this.pushCount(1), "t6", 14);

            case 14:
              this.flowKey = false;
              this.flowLevel = 1;
              return _context6.abrupt("return", 'flow');

            case 17:
              return _context6.delegateYield(this.pushCount(1), "t7", 18);

            case 18:
              return _context6.abrupt("return", 'doc');

            case 19:
              return _context6.delegateYield(this.pushUntil(isNotAnchorChar), "t8", 20);

            case 20:
              return _context6.abrupt("return", 'doc');

            case 21:
              return _context6.delegateYield(this.parseQuotedScalar(), "t9", 22);

            case 22:
              return _context6.abrupt("return", _context6.t9);

            case 23:
              _context6.t10 = n;
              return _context6.delegateYield(this.parseBlockScalarHeader(), "t11", 25);

            case 25:
              n = _context6.t10 += _context6.t11;
              _context6.t12 = n;
              return _context6.delegateYield(this.pushSpaces(true), "t13", 28);

            case 28:
              n = _context6.t12 += _context6.t13;
              return _context6.delegateYield(this.pushCount(line.length - n), "t14", 30);

            case 30:
              return _context6.delegateYield(this.pushNewline(), "t15", 31);

            case 31:
              return _context6.delegateYield(this.parseBlockScalar(), "t16", 32);

            case 32:
              return _context6.abrupt("return", _context6.t16);

            case 33:
              return _context6.delegateYield(this.parsePlainScalar(), "t17", 34);

            case 34:
              return _context6.abrupt("return", _context6.t17);

            case 35:
            case "end":
              return _context6.stop();
          }
        }
      }, parseDocument, this);
    })
  }, {
    key: "parseFlowCollection",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseFlowCollection() {
      var nl, sp, indent, line, atFlowEndMarker, n, next;
      return _regeneratorRuntime.wrap(function parseFlowCollection$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              indent = -1;

            case 1:
              return _context7.delegateYield(this.pushNewline(), "t0", 2);

            case 2:
              nl = _context7.t0;

              if (!(nl > 0)) {
                _context7.next = 9;
                break;
              }

              return _context7.delegateYield(this.pushSpaces(false), "t1", 5);

            case 5:
              sp = _context7.t1;
              this.indentValue = indent = sp;
              _context7.next = 10;
              break;

            case 9:
              sp = 0;

            case 10:
              _context7.t2 = sp;
              return _context7.delegateYield(this.pushSpaces(true), "t3", 12);

            case 12:
              sp = _context7.t2 += _context7.t3;

            case 13:
              if (nl + sp > 0) {
                _context7.next = 1;
                break;
              }

            case 14:
              line = this.getLine();

              if (!(line === null)) {
                _context7.next = 17;
                break;
              }

              return _context7.abrupt("return", this.setNext('flow'));

            case 17:
              if (!(indent !== -1 && indent < this.indentNext && line[0] !== '#' || indent === 0 && (line.startsWith('---') || line.startsWith('...')) && isEmpty(line[3]))) {
                _context7.next = 25;
                break;
              }

              // Allowing for the terminal ] or } at the same (rather than greater)
              // indent level as the initial [ or { is technically invalid, but
              // failing here would be surprising to users.
              atFlowEndMarker = indent === this.indentNext - 1 && this.flowLevel === 1 && (line[0] === ']' || line[0] === '}');

              if (atFlowEndMarker) {
                _context7.next = 25;
                break;
              }

              // this is an error
              this.flowLevel = 0;
              _context7.next = 23;
              return FLOW_END;

            case 23:
              return _context7.delegateYield(this.parseLineStart(), "t4", 24);

            case 24:
              return _context7.abrupt("return", _context7.t4);

            case 25:
              n = 0;

            case 26:
              if (!(line[n] === ',')) {
                _context7.next = 36;
                break;
              }

              _context7.t5 = n;
              return _context7.delegateYield(this.pushCount(1), "t6", 29);

            case 29:
              n = _context7.t5 += _context7.t6;
              _context7.t7 = n;
              return _context7.delegateYield(this.pushSpaces(true), "t8", 32);

            case 32:
              n = _context7.t7 += _context7.t8;
              this.flowKey = false;
              _context7.next = 26;
              break;

            case 36:
              _context7.t9 = n;
              return _context7.delegateYield(this.pushIndicators(), "t10", 38);

            case 38:
              n = _context7.t9 += _context7.t10;
              _context7.t11 = line[n];
              _context7.next = _context7.t11 === undefined ? 42 : _context7.t11 === '#' ? 43 : _context7.t11 === '{' ? 45 : _context7.t11 === '[' ? 45 : _context7.t11 === '}' ? 49 : _context7.t11 === ']' ? 49 : _context7.t11 === '*' ? 53 : _context7.t11 === '"' ? 55 : _context7.t11 === "'" ? 55 : _context7.t11 === ':' ? 58 : 64;
              break;

            case 42:
              return _context7.abrupt("return", 'flow');

            case 43:
              return _context7.delegateYield(this.pushCount(line.length - n), "t12", 44);

            case 44:
              return _context7.abrupt("return", 'flow');

            case 45:
              return _context7.delegateYield(this.pushCount(1), "t13", 46);

            case 46:
              this.flowKey = false;
              this.flowLevel += 1;
              return _context7.abrupt("return", 'flow');

            case 49:
              return _context7.delegateYield(this.pushCount(1), "t14", 50);

            case 50:
              this.flowKey = true;
              this.flowLevel -= 1;
              return _context7.abrupt("return", this.flowLevel ? 'flow' : 'doc');

            case 53:
              return _context7.delegateYield(this.pushUntil(isNotAnchorChar), "t15", 54);

            case 54:
              return _context7.abrupt("return", 'flow');

            case 55:
              this.flowKey = true;
              return _context7.delegateYield(this.parseQuotedScalar(), "t16", 57);

            case 57:
              return _context7.abrupt("return", _context7.t16);

            case 58:
              next = this.charAt(1);

              if (!(this.flowKey || isEmpty(next) || next === ',')) {
                _context7.next = 64;
                break;
              }

              this.flowKey = false;
              return _context7.delegateYield(this.pushCount(1), "t17", 62);

            case 62:
              return _context7.delegateYield(this.pushSpaces(true), "t18", 63);

            case 63:
              return _context7.abrupt("return", 'flow');

            case 64:
              this.flowKey = false;
              return _context7.delegateYield(this.parsePlainScalar(), "t19", 66);

            case 66:
              return _context7.abrupt("return", _context7.t19);

            case 67:
            case "end":
              return _context7.stop();
          }
        }
      }, parseFlowCollection, this);
    })
  }, {
    key: "parseQuotedScalar",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseQuotedScalar() {
      var quote, end, n, qb, nl, cs;
      return _regeneratorRuntime.wrap(function parseQuotedScalar$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              quote = this.charAt(0);
              end = this.buffer.indexOf(quote, this.pos + 1);

              if (!(quote === "'")) {
                _context8.next = 6;
                break;
              }

              while (end !== -1 && this.buffer[end + 1] === "'") {
                end = this.buffer.indexOf("'", end + 2);
              }

              _context8.next = 14;
              break;

            case 6:
              if (!(end !== -1)) {
                _context8.next = 14;
                break;
              }

              n = 0;

              while (this.buffer[end - 1 - n] === '\\') {
                n += 1;
              }

              if (!(n % 2 === 0)) {
                _context8.next = 11;
                break;
              }

              return _context8.abrupt("break", 14);

            case 11:
              end = this.buffer.indexOf('"', end + 1);
              _context8.next = 6;
              break;

            case 14:
              // Only looking for newlines within the quotes
              qb = this.buffer.substring(0, end);
              nl = qb.indexOf('\n', this.pos);

              if (!(nl !== -1)) {
                _context8.next = 25;
                break;
              }

            case 17:
              if (!(nl !== -1)) {
                _context8.next = 24;
                break;
              }

              cs = this.continueScalar(nl + 1);

              if (!(cs === -1)) {
                _context8.next = 21;
                break;
              }

              return _context8.abrupt("break", 24);

            case 21:
              nl = qb.indexOf('\n', cs);
              _context8.next = 17;
              break;

            case 24:
              if (nl !== -1) {
                // this is an error caused by an unexpected unindent
                end = nl - (qb[nl - 1] === '\r' ? 2 : 1);
              }

            case 25:
              if (!(end === -1)) {
                _context8.next = 29;
                break;
              }

              if (this.atEnd) {
                _context8.next = 28;
                break;
              }

              return _context8.abrupt("return", this.setNext('quoted-scalar'));

            case 28:
              end = this.buffer.length;

            case 29:
              return _context8.delegateYield(this.pushToIndex(end + 1, false), "t0", 30);

            case 30:
              return _context8.abrupt("return", this.flowLevel ? 'flow' : 'doc');

            case 31:
            case "end":
              return _context8.stop();
          }
        }
      }, parseQuotedScalar, this);
    })
  }, {
    key: "parseBlockScalarHeader",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseBlockScalarHeader() {
      var i, ch;
      return _regeneratorRuntime.wrap(function parseBlockScalarHeader$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              this.blockScalarIndent = -1;
              this.blockScalarKeep = false;
              i = this.pos;

            case 3:
              if (!true) {
                _context9.next = 17;
                break;
              }

              ch = this.buffer[++i];

              if (!(ch === '+')) {
                _context9.next = 9;
                break;
              }

              this.blockScalarKeep = true;
              _context9.next = 15;
              break;

            case 9:
              if (!(ch > '0' && ch <= '9')) {
                _context9.next = 13;
                break;
              }

              this.blockScalarIndent = Number(ch) - 1;
              _context9.next = 15;
              break;

            case 13:
              if (!(ch !== '-')) {
                _context9.next = 15;
                break;
              }

              return _context9.abrupt("break", 17);

            case 15:
              _context9.next = 3;
              break;

            case 17:
              return _context9.delegateYield(this.pushUntil(function (ch) {
                return isEmpty(ch) || ch === '#';
              }), "t0", 18);

            case 18:
              return _context9.abrupt("return", _context9.t0);

            case 19:
            case "end":
              return _context9.stop();
          }
        }
      }, parseBlockScalarHeader, this);
    })
  }, {
    key: "parseBlockScalar",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parseBlockScalar() {
      var nl, indent, ch, _i2, next, cs, i, _i3, _ch2, lastChar;

      return _regeneratorRuntime.wrap(function parseBlockScalar$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              nl = this.pos - 1; // may be -1 if this.pos === 0

              indent = 0;
              _i2 = this.pos;

            case 3:
              if (!(ch = this.buffer[_i2])) {
                _context10.next = 21;
                break;
              }

              _context10.t0 = ch;
              _context10.next = _context10.t0 === ' ' ? 7 : _context10.t0 === '\n' ? 9 : _context10.t0 === '\r' ? 12 : 17;
              break;

            case 7:
              indent += 1;
              return _context10.abrupt("break", 18);

            case 9:
              nl = _i2;
              indent = 0;
              return _context10.abrupt("break", 18);

            case 12:
              next = this.buffer[_i2 + 1];

              if (!(!next && !this.atEnd)) {
                _context10.next = 15;
                break;
              }

              return _context10.abrupt("return", this.setNext('block-scalar'));

            case 15:
              if (!(next === '\n')) {
                _context10.next = 17;
                break;
              }

              return _context10.abrupt("break", 18);

            case 17:
              return _context10.abrupt("break", 21);

            case 18:
              ++_i2;
              _context10.next = 3;
              break;

            case 21:
              if (!(!ch && !this.atEnd)) {
                _context10.next = 23;
                break;
              }

              return _context10.abrupt("return", this.setNext('block-scalar'));

            case 23:
              if (!(indent >= this.indentNext)) {
                _context10.next = 34;
                break;
              }

              if (this.blockScalarIndent === -1) this.indentNext = indent;else {
                this.indentNext = this.blockScalarIndent + (this.indentNext === 0 ? 1 : this.indentNext);
              }

            case 25:
              cs = this.continueScalar(nl + 1);

              if (!(cs === -1)) {
                _context10.next = 28;
                break;
              }

              return _context10.abrupt("break", 30);

            case 28:
              nl = this.buffer.indexOf('\n', cs);

            case 29:
              if (nl !== -1) {
                _context10.next = 25;
                break;
              }

            case 30:
              if (!(nl === -1)) {
                _context10.next = 34;
                break;
              }

              if (this.atEnd) {
                _context10.next = 33;
                break;
              }

              return _context10.abrupt("return", this.setNext('block-scalar'));

            case 33:
              nl = this.buffer.length;

            case 34:
              // Trailing insufficiently indented tabs are invalid.
              // To catch that during parsing, we include them in the block scalar value.
              i = nl + 1;
              ch = this.buffer[i];

              while (ch === ' ') {
                ch = this.buffer[++i];
              }

              if (!(ch === '\t')) {
                _context10.next = 42;
                break;
              }

              while (ch === '\t' || ch === ' ' || ch === '\r' || ch === '\n') {
                ch = this.buffer[++i];
              }

              nl = i - 1;
              _context10.next = 54;
              break;

            case 42:
              if (this.blockScalarKeep) {
                _context10.next = 54;
                break;
              }

            case 43:
              _i3 = nl - 1;
              _ch2 = this.buffer[_i3];
              if (_ch2 === '\r') _ch2 = this.buffer[--_i3];
              lastChar = _i3; // Drop the line if last char not more indented

              while (_ch2 === ' ') {
                _ch2 = this.buffer[--_i3];
              }

              if (!(_ch2 === '\n' && _i3 >= this.pos && _i3 + 1 + indent > lastChar)) {
                _context10.next = 52;
                break;
              }

              nl = _i3;
              _context10.next = 53;
              break;

            case 52:
              return _context10.abrupt("break", 54);

            case 53:
              if (true) {
                _context10.next = 43;
                break;
              }

            case 54:
              _context10.next = 56;
              return SCALAR;

            case 56:
              return _context10.delegateYield(this.pushToIndex(nl + 1, true), "t1", 57);

            case 57:
              return _context10.delegateYield(this.parseLineStart(), "t2", 58);

            case 58:
              return _context10.abrupt("return", _context10.t2);

            case 59:
            case "end":
              return _context10.stop();
          }
        }
      }, parseBlockScalar, this);
    })
  }, {
    key: "parsePlainScalar",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function parsePlainScalar() {
      var inFlow, end, i, ch, next, _next, cs;

      return _regeneratorRuntime.wrap(function parsePlainScalar$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              inFlow = this.flowLevel > 0;
              end = this.pos - 1;
              i = this.pos - 1;

            case 3:
              if (!(ch = this.buffer[++i])) {
                _context11.next = 28;
                break;
              }

              if (!(ch === ':')) {
                _context11.next = 11;
                break;
              }

              next = this.buffer[i + 1];

              if (!(isEmpty(next) || inFlow && flowIndicatorChars.has(next))) {
                _context11.next = 8;
                break;
              }

              return _context11.abrupt("break", 28);

            case 8:
              end = i;
              _context11.next = 26;
              break;

            case 11:
              if (!isEmpty(ch)) {
                _context11.next = 23;
                break;
              }

              _next = this.buffer[i + 1];

              if (ch === '\r') {
                if (_next === '\n') {
                  i += 1;
                  ch = '\n';
                  _next = this.buffer[i + 1];
                } else end = i;
              }

              if (!(_next === '#' || inFlow && flowIndicatorChars.has(_next))) {
                _context11.next = 16;
                break;
              }

              return _context11.abrupt("break", 28);

            case 16:
              if (!(ch === '\n')) {
                _context11.next = 21;
                break;
              }

              cs = this.continueScalar(i + 1);

              if (!(cs === -1)) {
                _context11.next = 20;
                break;
              }

              return _context11.abrupt("break", 28);

            case 20:
              i = Math.max(i, cs - 2); // to advance, but still account for ' #'

            case 21:
              _context11.next = 26;
              break;

            case 23:
              if (!(inFlow && flowIndicatorChars.has(ch))) {
                _context11.next = 25;
                break;
              }

              return _context11.abrupt("break", 28);

            case 25:
              end = i;

            case 26:
              _context11.next = 3;
              break;

            case 28:
              if (!(!ch && !this.atEnd)) {
                _context11.next = 30;
                break;
              }

              return _context11.abrupt("return", this.setNext('plain-scalar'));

            case 30:
              _context11.next = 32;
              return SCALAR;

            case 32:
              return _context11.delegateYield(this.pushToIndex(end + 1, true), "t0", 33);

            case 33:
              return _context11.abrupt("return", inFlow ? 'flow' : 'doc');

            case 34:
            case "end":
              return _context11.stop();
          }
        }
      }, parsePlainScalar, this);
    })
  }, {
    key: "pushCount",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pushCount(n) {
      return _regeneratorRuntime.wrap(function pushCount$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (!(n > 0)) {
                _context12.next = 5;
                break;
              }

              _context12.next = 3;
              return this.buffer.substr(this.pos, n);

            case 3:
              this.pos += n;
              return _context12.abrupt("return", n);

            case 5:
              return _context12.abrupt("return", 0);

            case 6:
            case "end":
              return _context12.stop();
          }
        }
      }, pushCount, this);
    })
  }, {
    key: "pushToIndex",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pushToIndex(i, allowEmpty) {
      var s;
      return _regeneratorRuntime.wrap(function pushToIndex$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              s = this.buffer.slice(this.pos, i);

              if (!s) {
                _context13.next = 8;
                break;
              }

              _context13.next = 4;
              return s;

            case 4:
              this.pos += s.length;
              return _context13.abrupt("return", s.length);

            case 8:
              if (!allowEmpty) {
                _context13.next = 11;
                break;
              }

              _context13.next = 11;
              return '';

            case 11:
              return _context13.abrupt("return", 0);

            case 12:
            case "end":
              return _context13.stop();
          }
        }
      }, pushToIndex, this);
    })
  }, {
    key: "pushIndicators",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pushIndicators() {
      var inFlow, ch1;
      return _regeneratorRuntime.wrap(function pushIndicators$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              _context14.t0 = this.charAt(0);
              _context14.next = _context14.t0 === '!' ? 3 : _context14.t0 === '&' ? 11 : _context14.t0 === '-' ? 19 : _context14.t0 === '?' ? 19 : _context14.t0 === ':' ? 19 : 31;
              break;

            case 3:
              return _context14.delegateYield(this.pushTag(), "t1", 4);

            case 4:
              _context14.t2 = _context14.t1;
              return _context14.delegateYield(this.pushSpaces(true), "t3", 6);

            case 6:
              _context14.t4 = _context14.t3;
              _context14.t5 = _context14.t2 + _context14.t4;
              return _context14.delegateYield(this.pushIndicators(), "t6", 9);

            case 9:
              _context14.t7 = _context14.t6;
              return _context14.abrupt("return", _context14.t5 + _context14.t7);

            case 11:
              return _context14.delegateYield(this.pushUntil(isNotAnchorChar), "t8", 12);

            case 12:
              _context14.t9 = _context14.t8;
              return _context14.delegateYield(this.pushSpaces(true), "t10", 14);

            case 14:
              _context14.t11 = _context14.t10;
              _context14.t12 = _context14.t9 + _context14.t11;
              return _context14.delegateYield(this.pushIndicators(), "t13", 17);

            case 17:
              _context14.t14 = _context14.t13;
              return _context14.abrupt("return", _context14.t12 + _context14.t14);

            case 19:
              inFlow = this.flowLevel > 0;
              ch1 = this.charAt(1);

              if (!(isEmpty(ch1) || inFlow && flowIndicatorChars.has(ch1))) {
                _context14.next = 31;
                break;
              }

              if (!inFlow) this.indentNext = this.indentValue + 1;else if (this.flowKey) this.flowKey = false;
              return _context14.delegateYield(this.pushCount(1), "t15", 24);

            case 24:
              _context14.t16 = _context14.t15;
              return _context14.delegateYield(this.pushSpaces(true), "t17", 26);

            case 26:
              _context14.t18 = _context14.t17;
              _context14.t19 = _context14.t16 + _context14.t18;
              return _context14.delegateYield(this.pushIndicators(), "t20", 29);

            case 29:
              _context14.t21 = _context14.t20;
              return _context14.abrupt("return", _context14.t19 + _context14.t21);

            case 31:
              return _context14.abrupt("return", 0);

            case 32:
            case "end":
              return _context14.stop();
          }
        }
      }, pushIndicators, this);
    })
  }, {
    key: "pushTag",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pushTag() {
      var i, ch, _i4, _ch3;

      return _regeneratorRuntime.wrap(function pushTag$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              if (!(this.charAt(1) === '<')) {
                _context15.next = 8;
                break;
              }

              i = this.pos + 2;
              ch = this.buffer[i];

              while (!isEmpty(ch) && ch !== '>') {
                ch = this.buffer[++i];
              }

              return _context15.delegateYield(this.pushToIndex(ch === '>' ? i + 1 : i, false), "t0", 5);

            case 5:
              return _context15.abrupt("return", _context15.t0);

            case 8:
              _i4 = this.pos + 1;
              _ch3 = this.buffer[_i4];

            case 10:
              if (!_ch3) {
                _context15.next = 22;
                break;
              }

              if (!tagChars.has(_ch3)) {
                _context15.next = 15;
                break;
              }

              _ch3 = this.buffer[++_i4];
              _context15.next = 20;
              break;

            case 15:
              if (!(_ch3 === '%' && hexDigits.has(this.buffer[_i4 + 1]) && hexDigits.has(this.buffer[_i4 + 2]))) {
                _context15.next = 19;
                break;
              }

              _ch3 = this.buffer[_i4 += 3];
              _context15.next = 20;
              break;

            case 19:
              return _context15.abrupt("break", 22);

            case 20:
              _context15.next = 10;
              break;

            case 22:
              return _context15.delegateYield(this.pushToIndex(_i4, false), "t1", 23);

            case 23:
              return _context15.abrupt("return", _context15.t1);

            case 24:
            case "end":
              return _context15.stop();
          }
        }
      }, pushTag, this);
    })
  }, {
    key: "pushNewline",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pushNewline() {
      var ch;
      return _regeneratorRuntime.wrap(function pushNewline$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              ch = this.buffer[this.pos];

              if (!(ch === '\n')) {
                _context16.next = 6;
                break;
              }

              return _context16.delegateYield(this.pushCount(1), "t0", 3);

            case 3:
              return _context16.abrupt("return", _context16.t0);

            case 6:
              if (!(ch === '\r' && this.charAt(1) === '\n')) {
                _context16.next = 11;
                break;
              }

              return _context16.delegateYield(this.pushCount(2), "t1", 8);

            case 8:
              return _context16.abrupt("return", _context16.t1);

            case 11:
              return _context16.abrupt("return", 0);

            case 12:
            case "end":
              return _context16.stop();
          }
        }
      }, pushNewline, this);
    })
  }, {
    key: "pushSpaces",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pushSpaces(allowTabs) {
      var i, ch, n;
      return _regeneratorRuntime.wrap(function pushSpaces$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              i = this.pos - 1;

              do {
                ch = this.buffer[++i];
              } while (ch === ' ' || allowTabs && ch === '\t');

              n = i - this.pos;

              if (!(n > 0)) {
                _context17.next = 7;
                break;
              }

              _context17.next = 6;
              return this.buffer.substr(this.pos, n);

            case 6:
              this.pos = i;

            case 7:
              return _context17.abrupt("return", n);

            case 8:
            case "end":
              return _context17.stop();
          }
        }
      }, pushSpaces, this);
    })
  }, {
    key: "pushUntil",
    value: /*#__PURE__*/_regeneratorRuntime.mark(function pushUntil(test) {
      var i, ch;
      return _regeneratorRuntime.wrap(function pushUntil$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              i = this.pos;
              ch = this.buffer[i];

              while (!test(ch)) {
                ch = this.buffer[++i];
              }

              return _context18.delegateYield(this.pushToIndex(i, false), "t0", 4);

            case 4:
              return _context18.abrupt("return", _context18.t0);

            case 5:
            case "end":
              return _context18.stop();
          }
        }
      }, pushUntil, this);
    })
  }]);

  return Lexer;
}();

export { Lexer };